import React from "react";
import Classes from "../AddAppointment.module.css";
import SelectDropdown from "../Dropdown/SelectDropdown";

const COUNTRIES = [
  { value: "USA", label: "United States" },
  { value: "CAN", label: "Canada" },
  { value: "MEX", label: "Mexico" },
];

export default function Step3Location({
  draft,
  setLocation,
  savedAddresses,
  onSelectSavedAddress,
  back,
  finish,
}) {
  const l = draft.location;

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setLocation({ [name]: type === "checkbox" ? checked : value });
  };

  return (
    <form
      className={Classes.infoCon}
      onSubmit={(e) => {
        e.preventDefault();
        finish();
      }}
    >
      <div className={Classes.infoConMiddle}>
        <h3 style={{ marginBottom: 10 }}>Location Info</h3>

        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <div className={Classes.flexAlign10}>
              <h5 className={Classes.label}>Select Address</h5>
              <span className={"optionalText"}> <h5>Optional</h5> </span>
            </div>
            <SelectDropdown
              options={savedAddresses}
              selected={l.selectedAddressId}
              onChange={(val) => onSelectSavedAddress(val)}
              placeholder={savedAddresses.length ? "Choose saved address" : "No saved addresses"}
              multiple={false}
              disabled={!savedAddresses.length}
              searchPlaceholder="Search addresses"
            />
          </div>
        </div>

        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Address</h5>
            <input
              className={Classes.inputField}
              name="address1"
              value={l.address1}
              onChange={onChange}
              placeholder="Street address"
              required
            />
          </div>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>City</h5>
            <input
              className={Classes.inputField}
              name="city"
              value={l.city}
              onChange={onChange}
              placeholder="City"
              required
            />
          </div>
        </div>

        <div className={Classes.flexColGroup}>
          {/* <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Country</h5>
            <SelectDropdown
              options={COUNTRIES}
              selected={l.country}
              onChange={(val) => setLocation({ country: val })}
              placeholder="Select Country"
              multiple={false}
            />
          </div> */}

          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>State / Province / Region</h5>
            <input
              className={Classes.inputField}
              name="region"
              value={l.region}
              onChange={onChange}
              placeholder="State / Province / Region"
              required
            />
          </div>

          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Postal / Zip Code</h5>
            <input
              className={Classes.inputField}
              name="postalCode"
              value={l.postalCode}
              onChange={onChange}
              placeholder="Zip"
              required
            />
          </div>
        </div>

        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <div className={Classes.flexAlign10}>
              <h5 className={Classes.label}>Neighborhood</h5>
              <span className={"optionalText"}> <h5>Optional</h5> </span>
            </div>
            <input
              className={Classes.inputField}
              name="neighborhood"
              value={l.neighborhood}
              onChange={onChange}
              placeholder="Neighborhood (Optional)"
            />
          </div>
        </div>

        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <div className={Classes.flexAlign10}>
              <h5 className={Classes.label}>Gate Code/Access Instructions</h5>
              <span className={"optionalText"}> <h5>Optional</h5> </span>
            </div>
            <input
              className={Classes.inputField}
              name="gateCode"
              value={l.gateCode}
              onChange={onChange}
              placeholder="e.g. Gate code, guard name, etc."
            />
          </div>
        </div>

        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <div className={Classes.flexAlign10}>
              <h5 className={Classes.label}>Parking Spot # or Detailed Location Notes</h5>
              <span className={"optionalText"}> <h5>Optional</h5> </span>
            </div>
            <input
              className={Classes.inputField}
              name="parkingSpotOrNotes"
              value={l.parkingSpotOrNotes}
              onChange={onChange}
              placeholder="Parking / landmark / notes"
            />
          </div>
        </div>

        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <div className={Classes.textAreaCon}>
              <textarea
                rows={4}
                name="additionalNotes"
                placeholder="Additional Notes (Optional)"
                value={l.additionalNotes}
                onChange={onChange}
              />
            </div>
          </div>
        </div>

        <div className={Classes.flexColGroup}>
          <label className={Classes.checkRow} style={{ userSelect: "none" }}>
            <input
              type="checkbox"
              name="confirmGasCap"
              checked={!!l.confirmGasCap}
              onChange={onChange}
              style={{ width: 16, height: 16 }}
            />
            <span>I confirm the gas cap is unlocked and accessible</span>
          </label>
        </div>
      </div>

      <div className={Classes.navRow}>
        <button type="button" className={Classes.backBtn} onClick={back}>
          <h5>Back</h5>
        </button>
        <button type="submit" className={Classes.saveBtn}>
          <h5>Finish</h5>
        </button>
      </div>
    </form>
  );
}
